export const INFO = 1;
export const WAVEFORM = 2;
export const PIANO_ROLL = 3;
export const EFFECTS = 4; // todo: when i re-enable effects move this to 4

export const MODE_TO_HEIGHT = (mode) => {
    switch (mode) {
    case PIANO_ROLL:
        return window.innerHeight - 280;
    default:
        return 380;
    }
};
